<template>
  <div
    class="detail-container all-box"
    v-if="datas"
    v-loading="isLoading"
    ref="contentContainer"
  >
    <Header :scrollPosition="scrollPosition" />
    <ActiveDetail
      v-if="datas"
      :active="datas.datas"
      :hasChange="hasChange"
      @submit="handleSubmit"
      @cancel="handleCancel"
      @signUp="handleSignUp"
      @handleCountDown="handleChange($event)"
    />
  </div>
</template>

<script>
import fetchData from "@/mixins/fetchData.js";
import mainScroll from "@/mixins/mainScroll.js";
import {
  getActive,
  postActive,
  cancelActive,
  signUpActive,
} from "@/api/active.js";
import Header from "@/components/util/Header";
import ActiveDetail from "./components/ActiveDetail";
import { titleController } from "@/utils";
export default {
  components: {
    Header,
    ActiveDetail,
  },
  mixins: [fetchData({ datas: {} }), mainScroll("contentContainer")],
  data() {
    return {
      storage: window.localStorage,
      hasChange: 1,
      scrollPosition: 0,
    };
  },
  created() {
    this.$bus.$on("mainScroll", this.handleScroll);
  },
  unmounted() {
    this.$bus.$off("mainScroll", this.handleScroll);
  },
  methods: {
    async fetchData() {
      const resp = await getActive(
        this.storage.getItem("uid"),
        this.storage.getItem("usertoken"),
        this.$route.params.aid
      );
      if (!resp.status) {
        //文章不存在
        this.$router.push("/404");
      }
      titleController.setRouteTitle(resp.datas.title);
      return resp;
    },
    async handleSubmit(formData, callback) {
      const resp = await postActive({
        aid: this.$route.params.aid,
        uid: this.storage.getItem("uid"),
        usertoken: this.storage.getItem("usertoken"),
        ...formData,
      });
      const scrollHeight = this.$refs.contentContainer.scrollHeight;
      if (!resp.status) {
        this.$refs.contentContainer.scrollTo({
          top: scrollHeight,
          behavior: "smooth",
        });
      }

      callback(resp.status, resp.message);
    },
    async handleCancel(formData, callback) {
      const resp = await cancelActive({
        aid: this.$route.params.aid,
        uid: this.storage.getItem("uid"),
        usertoken: this.storage.getItem("usertoken"),
        ...formData,
      });
      callback(resp.status, resp.message);
    },
    handleChange(hasChange) {
      this.hasChange = hasChange;
    },

    async handleSignUp(signupcode, callback) {
      const resp = await signUpActive({
        aid: this.$route.params.aid,
        uid: this.storage.getItem("uid"),
        usertoken: this.storage.getItem("usertoken"),
        code: signupcode,
      });

      callback(resp.status, resp.message);
    },
    handleScroll(dom) {
      if (!dom) {
        return;
      }
      if (dom.scrollTop > 0) {
        this.scrollPosition = dom.scrollTop;
      } else {
        this.scrollPosition = 0;
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/styles/mixin.less";
.detail-container {
  position: relative;
  margin: auto;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-behavior: smooth;
}
</style>